<template>
  <div class="page-content-wrapper"  v-check-permission="'edit-payments'">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card m-b-20">
            <div class="card-block">

              <template v-if="payment">
                <div class="invoice-title row">
                  <h4 class="mt-0 header-title col-md-8 mb-0">Pagos</h4>
                  <span class="text-right col-md-4"> #{{ payment._id }}</span>
                </div>

                <hr>

                <div class="panel panel-default pb-0 mb-0">
                  <div class="p-2">

                    <div class="row mt-1">

                      <div class="col-md-4">
                        <address>
                          <strong>Tipo de pago</strong>
                          <p>
                            <span class="badge badge-warning" v-if="payment.paymentType == 'fee'">Cuota</span>
                            <span class="badge badge-info" v-if="payment.paymentType == 'enrollment'">Matrícula</span>
                            <span class="badge badge-dark" v-if="payment.paymentType == 'custom'">Personalizado</span>
                          </p>
                        </address>
                      </div>

                      <div class="col-md-4">
                        <address>
                          <strong>Estado</strong>
                          <select id="paymentStatus" class="custom-select form-control d-block w-75" v-model="payment.paymentStatus">
                            <option v-for="state in paymentStatus" :value="state.value">
                              {{ state.text }}
                            </option>
                          </select>
                        </address>
                      </div>

                      <div class="col-md-4">
                        <address>
                          <strong>Método de pago</strong>
                          <select id="paymentMethods" class="custom-select form-control d-block w-75" v-model="payment.paymentMethod">
                            <option v-for="method in paymentMethods" :value="method.value">
                              {{ method.text }}
                            </option>
                          </select>
                        </address>
                      </div>

                    </div>

                    <div class="row mt-1">

                      <div class="col-md-4">
                        <address>
                          <strong>Vencimiento</strong>
                          <p>{{ payment.dueDate | moment("dddd, DD MMMM YYYY") }}</p>
                        </address>
                      </div>

                      <div class="col-md-4">
                        <address>
                          <strong>Fecha de pago</strong>
                          <p v-if="payment.paymentDate">{{ payment.paymentDate | moment("dddd, DD MMMM YYYY") }}</p>
                          <p v-else>--</p>
                        </address>
                      </div>

                      <div class="col-md-4">
                        <address>
                          <strong>Número de recibo</strong>
                          <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0 w-75"  v-model="payment.receiptNumber" />
                        </address>
                      </div>

                    </div>

                  </div>
                </div>


                <div class="row">
                  <div class="col-12">
                    <div class="panel panel-default mt-0 pt-0 mb-0 pb-0">
                      <div class="pl-2 pr-2">
                        <h3 class="panel-title font-20"><strong>Datos del alumno</strong></h3>


                        <div class="row mt-3">

                          <div class="col-md-3">
                            <address>
                              <strong>DNI</strong>
                              <p>{{ studentFile.personalData.dni }}</p>
                            </address>
                          </div>

                          <div class="col-md-3">
                            <address>
                              <strong>CUIT/CUIL</strong>
                              <p>{{ studentFile.personalData.cuil }}</p>
                            </address>
                          </div>

                          <div class="col-md-3">
                            <address>
                              <strong>Apellido y nombre</strong>
                              <p>{{ studentFile.personalData.lastName }} {{ studentFile.personalData.firstName }}</p>
                            </address>
                          </div>

                          <div class="col-md-3">
                            <address>
                              <strong>Fecha de Nacimiento</strong>
                              <p>{{ studentFile.personalData.birthDate | moment("dddd, DD MMMM YYYY") }}</p>
                            </address>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="panel panel-default mt-0 pt-0 mb-0 pb-0">
                      <div class="p-2">
                        <h3 class="panel-title font-20"><strong>Detalle</strong></h3>
                      </div>
                      <div class="">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                            <tr>
                              <td><strong>Item</strong></td>
                              <td class="text-center"><strong>Carrera</strong></td>
                              <td class="text-center"><strong>Monto</strong></td>
                              <td class="text-center"><strong></strong></td>
                              <td class="text-right"><strong>Total</strong></td>
                            </tr>
                            </thead>
                            <tbody>

                            <tr>
                              <td>{{ payment.title }}</td>
                              <td class="text-center">{{ career.name }}</td>
                              <td class="text-center">
                                <div class="input-group bootstrap-touchspin">
                                  <span class="input-group-addon bootstrap-touchspin-prefix">$</span>
                                  <input id="amount" type="number" v-model="payment.amount" class="form-control" style="display: block; width: 100px;">
                                  <span class="input-group-addon bootstrap-touchspin-postfix" style="display: none;"></span>
                                </div>
                              </td>
                              <td class="text-center"></td>
                              <td class="text-right">${{ payment.amount }}</td>
                            </tr>
                            <tr>
                              <td class="thick-line"></td>
                              <td class="thick-line"></td>
                              <td class="thick-line"></td>
                              <td class="thick-line text-center">
                                <strong>Subtotal</strong></td>
                              <td class="thick-line text-right">${{ payment.amount }}</td>
                            </tr>
                            <tr v-if="payment.paymentStatus == 'pending'">
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line text-center">
                                <strong>Descuento</strong></td>
                              <td class="no-line text-right">-${{ discountAmount }}</td>
                            </tr>
                            <tr v-if="payment.paymentStatus == 'pending'">
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line text-center">
                                <strong>Recargo</strong></td>
                              <td class="no-line text-right">+${{ interestAmount }}</td>
                            </tr>
                            <tr v-if="payment.paymentStatus == 'pending'">
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line text-center">
                                <strong>Total a pagar</strong></td>
                              <td class="no-line text-right"><h4 class="m-0">${{ totalAmount }}</h4></td>
                            </tr>
                            <tr>
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line text-center">
                                <strong>Monto pagado</strong></td>
                              <td class="no-line text-right">
                                <div class="input-group bootstrap-touchspin">
                                  <span class="input-group-addon bootstrap-touchspin-prefix">$</span>
                                  <input id="amountPaid" type="number" v-model="payment.amountPaid" class="form-control" style="display: block;">
                                  <span class="input-group-addon bootstrap-touchspin-postfix" style="display: none;"></span>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>

                        <div>
                          <div class="pull-right">
                            <router-link to="/list-payments" class="btn btn-secondary waves-effect m-r-10">Cancelar</router-link>
                            <a class="btn btn-primary waves-effect waves-light save-btn" @click="submit()">Guardar</a>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </template>

              <template v-else-if="!error">

                <div class="ex-page-content text-center">
                  <h1>Aguarde un momento</h1>
                  <span><i class="fa fa-smile-o icon"></i></span>
                  <h5 class="text-muted">En unos segundos se cargaran los datos para que puedas realizar el pago.</h5>
                </div>

              </template>

              <template v-if="error">

                <div class="ex-page-content text-center">
                  <h1>Ha ocurrido un error</h1>
                  <span><i class="fa fa-frown-o icon"></i></span>
                  <h5 class="text-muted">Para volver a intentarlo presiona el siguiente botón:</h5>

                  <a class="btn btn-info" href="javascript:void(0);" @click="getData()">Cargar de nuevo</a>
                </div>

              </template>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getPayment } from '../api'
  import paymentStatus from '../data/paymentStatus'
  import paymentMethods from '../data/paymentMethods'

  export default {
    name: 'edit-payment',


    created () {
      this.getData()
    },


    data () {
      return {
        paymentStatus: paymentStatus,
        paymentMethods: paymentMethods,
        payment: null,
        discountAmount: 0,
        interestAmount: 0,
        totalAmount: 0,
        career: null,
        studentFile: null,
        error: false
      }
    },


    methods: {

      getData: function () {

        this.$loader.loading();

        getPayment(this.$route.params.id)
          .then((response) => {

            if(response.body.success) {

              this.payment = response.body.data.payment;
              this.discountAmount = response.body.data.discountAmount;
              this.interestAmount = response.body.data.interestAmount;
              this.totalAmount = response.body.data.totalAmount;
              this.career = response.body.data.career;
              this.studentFile = response.body.data.studentFile;

            } else {

              this.error = true;
              this.$message.error({ text: response.body.message });

            }

            this.$loader.close();
          })
          .catch(error => {
            this.$message.error({ text: error });
            this.$loader.close();
          })

      },


      submit: function () {
        const self = this;

        if(this.payment.amount.length == 0 || this.payment.amount == 0) {
          self.$message.error({text: 'Debes ingresar un monto a la cuota mayor a cero.'});
          return false;
        }

        $('.save-btn').attr('disabled', true);

        this.$store.dispatch('editPayment', { payment: this.payment })
          .then((response) => {

            if(response.success) {
              self.$message.success();

              setTimeout(function () {
                self.$router.push('/list-payments')
              }, 500)

            } else {

              self.$message.error({text: response.message});

            }

            $('.save-btn').attr('disabled', false)
          })
          .catch((response) => {
            self.$message.error({text: response.message});
            $('.save-btn').attr('disabled', false)
          })
      }

    }
  }
</script>


<style scoped>
  h1 {
    font-size: 3em;
    line-height: normal;
    text-shadow: none;
  }
  .icon {
    font-size: 47px;
  }
  .card {
    min-height: 80vh;
  }
  .ex-page-content {
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/EditPaymentScreen.vue